module.exports = __webpack_public_path__ + "img/card_220270567.bfe2f710.png";